// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { messageBot16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-message-bot': IconMessageBot;
    }
}

/**
 * The icon component for the 'messageBot' icon
 */
export class IconMessageBot extends Icon {
    public constructor() {
        super(messageBot16X16);
    }
}

registerIcon('icon-message-bot', IconMessageBot);
export const iconMessageBotTag = 'nimble-icon-message-bot';
